import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;
const ACCESS_TOKEN = "ACCESS_TOKEN";
const USER = "USER";

const AuthService = {
  async login(email, password, isChecked) {
    try {
      const result = await axios.post(`${apiUrl}/authentication/login`, {
        email,
        password,
        isChecked
      });
      if (result) {
        // TODO: replace result.data.message by the token

        localStorage.clear();
        localStorage.setItem(ACCESS_TOKEN, result.data.token);
        localStorage.setItem(USER, result.data.user);
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  isAuthenticated() {
    const token = localStorage.getItem(ACCESS_TOKEN);
    let connected = false;
    if (token) {
      
      axios.defaults.headers.common['Authorization'] = token;
      connected = true;
      // return false;

    }
    // else{
    //   // TODO:
    //   axios.defaults.headers.common['Authorization'] = token;
    //   connected = true;
    //   return true;

    // }
    return connected;
  },

  logout () {
    localStorage.clear();
    return localStorage.removeItem(ACCESS_TOKEN);
  },
   getToken() {
    return localStorage.getItem('ACCESS_TOKEN');
  },

   decodeToken(token) {
    try {
      const base64Url = token.split('.')[1];
      const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
      const jsonPayload = decodeURIComponent(atob(base64).split('').map(c => {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      }).join(''));
      return JSON.parse(jsonPayload);
    } catch (error) {
      console.error('Erreur de décodage du token:', error);
      return null;
    }
  },

  getTokenExpirationTime(token) {
    const decoded = this.decodeToken(token);
    return decoded ? decoded.timestamp * 1000 : null;
  },

  getTimeRemaining(token) {
    if (!token) return 0;
    const expirationTime = this.getTokenExpirationTime(token);
    if (!expirationTime) return 0;
    
    const now = Date.now();
    const timeRemaining = expirationTime - now;
    return Math.max(0, timeRemaining);
  },

   isTokenExpired(token) {
    if (!token) return true;
    return this.getTimeRemaining(token) <= 0;
  },



   async refreshToken() {
    try {
      const token = this.getToken();
      if (!token) return { success: false, logout: true };

      // Adaptez cette partie selon votre API
      const response = await fetch('/api/refresh-token', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        const data = await response.json();
        return { success: true, token: data.token };
      }
      
      // Si 401, token invalide
      if (response.status === 401) {
        return { success: false, logout: true };
      }
      
      return { success: false };
    } catch (error) {
      console.error('Erreur lors du rafraîchissement:', error);
      return { success: false };
    }
  },

  
  //TODO: Permission user by the token zah
  /*getPermissions: () => {
     const role = localStorage.getItem('permissions');
     return role ? Promise.resolve(role) : Promise.reject();
}*/
  async refreshToken(){
      try {
          const result = await axios.get(`${apiUrl}/user/refreshToken`);
          if (result) {
            return result.data;
          }
        } 
        catch (error) {
          if (error.response) {
            return error.response.data;
          }
        }
      }
  ,

};

export default AuthService;
